import { render, staticRenderFns } from "./confirmation-modal.vue?vue&type=template&id=8a99e70c&scoped=true&lang=pug"
import script from "./confirmation-modal.vue?vue&type=script&lang=ts"
export * from "./confirmation-modal.vue?vue&type=script&lang=ts"
import style0 from "./confirmation-modal.vue?vue&type=style&index=0&id=8a99e70c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a99e70c",
  null
  
)

export default component.exports